import type {WalkerService} from 'shared/services';
import type {Auth, SearchHistoryEntryDto} from 'src/typings';
import type {SearchFormPageData} from './types';
import type {SearchFormDataService} from './search-form.data-service';
import type {KpSearchHistoryPanelPresenter} from '../kp-search-history-panel/kp-search-history-panel.presenter';
import type SearchHistoryDataService from '../search-history-page/search-history.data-service';
import type {AjaxService} from 'core/data-services/ajax.service';
import {transferify} from 'shared/utils/data-service-utils';
import type {Conjunction} from '../search-criteria/criteria.types';

export class KpSearchFormService {
    public static serviceName = 'kpSearchFormService';

    /*@ngInject*/
    constructor(private searchFormDataService: SearchFormDataService,
                private kpSearchHistoryPanelPresenter: KpSearchHistoryPanelPresenter,
                private ajaxService: AjaxService,
                public readonly searchHistoryDataService: SearchHistoryDataService,
                public readonly currentAuth: Auth,
                public readonly walker: WalkerService) {
    }

    public async getPageData(): Promise<SearchFormPageData> {
        return this.searchFormDataService.getPageData();
    }

    public registerSearchHistoryPanelFillToFormEventListener(handler: (event: CustomEvent<SearchHistoryEntryDto>) => void): () => void {
        return this.kpSearchHistoryPanelPresenter.registerFullToFormEventHandler(handler);
    }

    public async loadLuceneQuery(request: Conjunction) {
        return this.ajaxService.createRequest('query-conversion').post<string>(transferify(request), {dialect: 'lucene'});
    }
}